// extracted by mini-css-extract-plugin
module.exports = {"attention-box":"attention-box___19m8x"};